import { render, staticRenderFns } from "./compAdd.vue?vue&type=template&id=8c27f890&scoped=true"
import script from "./compAdd.vue?vue&type=script&lang=js"
export * from "./compAdd.vue?vue&type=script&lang=js"
import style0 from "./compAdd.vue?vue&type=style&index=0&id=8c27f890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c27f890",
  null
  
)

export default component.exports